import type { IconData } from '@stacksjs/iconify-core'

export const arrowheadsDownRight: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.16 15.84L15.84.16v15.68z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default arrowheadsDownRight
